import React, { useCallback, useMemo, useState } from 'react'
import { View as RNView } from 'react-native';
import { SimpleText, XStack, YStack, TipLineChart, XPPlatform as Platform, XPReactNative, useMedia, YGroup, ListItem, Separator, ActiveButton, View } from '@my/ui'
import { color, FormatUtils, MiscUtils } from '@my/util'
import { ChevronDown } from '@tamagui/lucide-icons-2'
const { FlatList, /* Platform */ } = XPReactNative

const dataLine = [
  { x: 'Sun', y: 200000 },
  { x: 'Mon', y: 150000 },
  { x: 'Tue', y: 300000 },
  { x: 'Wed', y: 250000 },
  { x: 'Thu', y: 150000 },
  { x: 'Fri', y: 105000 },
  { x: 'Sat', y: 200000 },
]

// Memoize ExpenseCategoryCard to avoid unnecessary re-renders
const ExpenseCategoryCard = React.memo(({ title, amountSpent, totalPercent, chartData, leftBorder }: any) => {

  const hasLeftBorder = leftBorder !== undefined ? leftBorder : true
  const percentAmount = parseFloat(totalPercent);
  return (
    <YStack>
      <YStack
        borderWidth={1}
        padding="$3"
        width={300}
        borderRadius="$4"
        paddingBottom={10}
        borderColor={'rgba(220, 224, 229, 0.5)'}
        {...(hasLeftBorder ? {borderLeftColor: color.tzaGreen, borderLeftWidth: 4} : {})}
        {...MiscUtils.ui.shadowGenerator(0.03, 5)}
      >
        <YStack gap={5} justifyContent="space-between" >
          {/* Title Section */}
          <SimpleText fontSize={14} fontWeight="400" color={color.darkNavy}>
            {title}
          </SimpleText>

          {/* Amount Details */}
          <YStack justifyContent="start" >
            <XStack width={'100%'} style={{alignItems: 'baseline'}} gap={5}>
              <SimpleText
                fontSize={20}
                //width={130}
                //textAlign="right"
                fontWeight="700"
                color={color.darkNavy}
              >
                {FormatUtils.currency.cashFormat(amountSpent)}
              </SimpleText>
              {/* <SimpleText fontSize={12} fontWeight="400" color={color.grey} textAlign="right">
                (Amount Spent)
              </SimpleText> */}
            </XStack>
            <XStack gap={5}>
              <SimpleText fontSize={14} fontWeight="400" color={color.grey}>
                % of Monthly Income:
              </SimpleText>
              <SimpleText fontSize={14} fontWeight="700" color={color.lightGrey}>
                {percentAmount.toFixed(percentAmount < 3 ? 2 : 0)}%
              </SimpleText>
            </XStack>
          </YStack>

          {/* Insight Charts */}
          {/* <InsightCharts width={Platform.OS === 'web' ? 300 : 270} data={chartData} /> */}
        </YStack>
      </YStack>
    </YStack>
  )
})

const InsightCharts = ({ width, data }: any) => {
  const groupLabels = [{ name: 'Income', fill: color.tzaGreen }]

  return (
    <TipLineChart
      dataSets={[data]}
      maxWidth={width}
      lineStyles={lineStyles}
      legendData={groupLabels}
      animate={false}
    />
  )
}

const lineStyles = [{ color: color.tzaGreen }]
export const ExpenseCategoryList = (props: { data: any[], collapsible?: boolean, leftBorder?: boolean }) => {
  const media = useMedia();
  return media['max-sm'] ? <ExpenseCategoryListMobile {...props} /> : <ExpenseCategoryListDesktop {...props} />;
}

const ExpenseCategoryListMobile = ({ data, collapsible, leftBorder }: { data: any[], collapsible?: boolean, leftBorder?: boolean }) => {
  const [isCollapsed, setIsCollapsed] = useState(!!collapsible);
  const newImpl = <View
    key={'collapseStack'}
    width={'100%'}
    style={{gap: 5, alignItems: 'center', flexDirection: 'column'}}
    {...(isCollapsed ? {display : 'none'} : {})}
  >{data.map((item, idx) => (
      <ExpenseCategoryCard
        key={idx}
        title={item?.category?.replace('(excluding groceries)', '')?.trim() || ''}
        amountSpent={item?.amountSpent}
        totalPercent={item['% of Monthly Salary']}
        chartData={dataLine}
        leftBorder={leftBorder}
      />
  ))}</View>
  
  const mainContent = Platform.select({
    web: newImpl,
    native: <RNView collapsable={false} key={'collapseKing'}>
      {newImpl}
    </RNView>
  }) ;

  const collapseShell = data?.length ? <YStack style={{alignItems: 'center', marginTop: 10, gap: 10}}>
    <ActiveButton
      onPress={() => setIsCollapsed((prev) => !prev)}
      variant={isCollapsed ? undefined : 'outlined'}
      style={{width: 150, paddingHorizontal: 0}}
      //iconAfter={<ChevronDown size="$1" transition="quick" rotate={isCollapsed ? '0deg' : '180deg'}/>}
      ButtonTextProps={{children: isCollapsed ? 'View Expenses' : 'Hide Expenses'}}
    />
    {mainContent}
  </YStack> : null

  return collapsible ? collapseShell : mainContent;
}

const ExpenseCategoryListDesktop = ({ data }: { data: any[] }) => {
  const renderItem = useCallback(
    ({ item }: { item: any }) => (
      <ExpenseCategoryCard
        title={item?.category?.replace('(excluding groceries)', '')?.trim() || ''}
        amountSpent={item?.amountSpent}
        totalPercent={item['% of Monthly Salary']}
        chartData={dataLine}
      />
    ),
    []
  )

  return (
    <FlatList
      data={data}
      horizontal
      showsHorizontalScrollIndicator={true}
      renderItem={renderItem}
      keyExtractor={(item) => item.category}
      contentContainerStyle={{ gap: 20 }}
      initialNumToRender={10}
      maxToRenderPerBatch={10}
      windowSize={5}
    />
  )
}
